import { omit } from 'lodash';

/**
 * Creates a map of the bottlebooksFields by bottlebooks key if mapped
 * @param {Object} props
 * @param {{bottlebooksFieldName: string}[]} props.bottlebooksFields
 * @param {{bottlebooksFieldName: string}[]} [props.latestBottlebooksFields]
 * @param {{name: string}[]} props.sourceFields
 * @param {{key: string}[]} props.fieldsToImport
 * @returns
 */
function getBottlebooksFieldsMap({
  bottlebooksFields,
  latestBottlebooksFields,
  sourceFields,
  fieldsToImport,
}) {
  if (!bottlebooksFields) {
    //use the configuration of the last completed import
    if (latestBottlebooksFields) {
      bottlebooksFields = latestBottlebooksFields;
    } else {
      bottlebooksFields = [];
    }
  }

  const fieldsToImportKeys = fieldsToImport?.map(({ key }) => key);

  /**
   * @type {Record<string, {importFieldName: string, bottlebooksFieldName: string}>}
   */
  const map = fieldsToImportKeys?.reduce((acc, key) => {
    const fieldMapping = bottlebooksFields?.find(
      (f) => f.bottlebooksFieldName === key
    );
    if (fieldMapping) {
      //matched by db mapping
      const cleaned = omit(fieldMapping, '__typename');
      acc[fieldMapping.bottlebooksFieldName] = cleaned;
    } else {
      //matched by exact name
      const nameMapped = sourceFields?.find(({ name }) => name === key);
      if (nameMapped) {
        acc[key] = {
          importFieldName: nameMapped.name,
          bottlebooksFieldName: key,
        };
      }
    }
    return acc;
  }, {});
  return map;
}
export default getBottlebooksFieldsMap;
